<!-- eslint-disable vue/multi-word-component-names -->
<script setup>
import { ref, reactive, computed, watch } from 'vue'
import { useVModel } from '@vueuse/core'

const treeProps = {
  label: 'name',
  children: 'children',
  isLeaf: 'leaf'
}

const $props = defineProps({
  modelValue: {
    type: [String, Array],
    default: null
  },
  multiple: {
    type: Boolean,
    default: false
  }
})

const $emits = defineEmits(['update:modelValue'])

const value = useVModel($props, 'modelValue', $emits)

const productTreeRef = ref()
const expandedKeys = ref([])
const dialogVisible = ref(false)
const queryForm = reactive({
  name: ''
})

// 模拟产品数据，实际应从API获取
const mockProducts = [
  { id: '1', name: '产品A', children: [
    { id: '1-1', name: '子产品A1' },
    { id: '1-2', name: '子产品A2' }
  ]},
  { id: '2', name: '产品B', children: [
    { id: '2-1', name: '子产品B1' }
  ]},
  { id: '3', name: '产品C' }
]

// 显示选中的产品名称
const selectedProductNames = computed(() => {
  if (!value.value || (Array.isArray(value.value) && value.value.length === 0)) {
    return ''
  }
  const ids = Array.isArray(value.value) ? value.value : [value.value]
  const names = []
  const findName = (nodes) => {
    for (const node of nodes) {
      if (ids.includes(node.id)) {
        names.push(node.name)
      }
      if (node.children) {
        findName(node.children)
      }
    }
  }
  findName(mockProducts)
  return names.join(', ')
})

watch(
  () => queryForm.name,
  (val) => {
    productTreeRef.value && productTreeRef.value.filter(val)
  }
)

const filterNode = (value, data) => {
  if (!value) return true
  return data.name.includes(value)
}

const open = () => {
  dialogVisible.value = true
  onOpen()
}

const onOpen = () => {
  let productIds = []
  if (Array.isArray(value.value)) {
    productIds.push(...value.value)
  } else if (value.value) {
    productIds.push(value.value)
  }

  // 设置已选中的产品
  if (productIds.length > 0) {
    productTreeRef.value && productTreeRef.value.setCheckedKeys(productIds)
  }
}

const onNodeClick = (data) => {
  if ($props.multiple) {
    const checkedKeys = productTreeRef.value?.getCheckedKeys() || []
    const index = checkedKeys.indexOf(data.id)
    if (index === -1) {
      checkedKeys.push(data.id)
    } else {
      checkedKeys.splice(index, 1)
    }
    productTreeRef.value?.setCheckedKeys(checkedKeys)
  } else {
    productTreeRef.value?.setCheckedKeys([data.id])
  }
}

const handleConfirm = () => {
  const checkedKeys = productTreeRef.value?.getCheckedKeys() || []
  if ($props.multiple) {
    value.value = checkedKeys
  } else {
    value.value = checkedKeys.length > 0 ? checkedKeys[0] : null
  }
  dialogVisible.value = false
}

defineExpose({
  open
})
</script>

<template>
  <div>
    <el-input
      v-model="selectedProductNames"
      readonly
      placeholder="选择产品"
      @click="open"
    >
      <template #append>
        <el-button @click="open">选择</el-button>
      </template>
    </el-input>

    <el-dialog
      v-model="dialogVisible"
      @open="onOpen"
      align-center
      title="选择产品"
      width="30%"
    >
      <el-card shadow="never" class="product-card">
        <template #header>
          <el-input
            v-model="queryForm.name"
            placeholder="输入关键字进行查询"
            :style="{ width: '100%' }"
            suffix-icon="search"
            clearable
          />
        </template>
        <el-scrollbar tag="div" class="product-tree">
          <el-tree
            ref="productTreeRef"
            :data="mockProducts"
            :props="treeProps"
            :filter-node-method="filterNode"
            node-key="id"
            show-checkbox
            :default-expanded-keys="expandedKeys"
            @node-click="onNodeClick"
          >
            <template #default="{ data }">
              <div class="flex items-center gap-2">
                <span>{{ data.name }}</span>
              </div>
            </template>
          </el-tree>
        </el-scrollbar>
      </el-card>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleConfirm">确认</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss">
.product-card {
  background-color: transparent;

  :deep(.el-card__header) {
    padding: 10px !important;
  }

  :deep(.el-card__body) {
    padding: 0 !important;
  }
}

.product-tree {
  height: 270px;
  padding: 5px;
}
</style>
